import { useDeferredValue } from "react"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

import { v4CustomersGeocode } from "@be-miniapp/api"
import type { Location } from "@be-miniapp/types"

interface locationsOfInterestProps {
  location: Location | null | undefined
  enabled?: boolean
}

export const geocodeQueryKeys = {
  all: ["locationGeocode"],
  point: (latitude: number | undefined, longitude: number | undefined) => [
    "locationGeocode",
    latitude,
    longitude,
  ],
}

const useGeocodeFromAPI = ({
  location,
  enabled = true,
}: locationsOfInterestProps) => {
  const { data, isFetched, isPending } = useQuery({
    queryKey: geocodeQueryKeys.point(location?.latitude, location?.longitude),
    queryFn: async () => {
      return v4CustomersGeocode({
        latitude: location?.latitude,
        longitude: location?.longitude,
        location: {
          latitude: location?.latitude ?? 0,
          longitude: location?.longitude ?? 0,
        },
      })
    },

    enabled:
      enabled &&
      !!location &&
      location?.latitude > 6.5 &&
      location?.longitude > 6.5,
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
  })

  const locationGeocode = useDeferredValue(data)

  return { locationGeocode, isFetched, isPending }
}

export { useGeocodeFromAPI }
